import { render } from "./sign-detail.vue?vue&type=template&id=5f9f8eaa&scoped=true&ts=true"
import script from "./sign-detail.vue?vue&type=script&lang=ts"
export * from "./sign-detail.vue?vue&type=script&lang=ts"

import "./sign-detail.vue?vue&type=style&index=0&id=5f9f8eaa&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9f8eaa"]])

export default __exports__